{
  "name": "travel-visitors-flow",
  "version": "8.3.1",
  "private": true,
  "type": "module",
  "scripts": {
    "dev": "FROM_ENV_FILE=true pnpm vite",
    "build": "vite build --mode production",
    "build:dev": "FROM_ENV_FILE=true pnpm build",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "lint": "eslint ./src",
    "lint:fix": "pnpm lint --fix",
    "type-check": "vue-tsc --noEmit -p tsconfig.json --composite false",
    "format": "prettier --write src/",
    "format:check": "prettier --debug-check src/ --log-level silent",
    "locales:upload": "ltu -p upload"
  },
  "dependencies": {
    "@qicgroupdoha/qic-connect-ds": "1.81.1",
    "@qicgroupdoha/qic-i18n": "1.0.7",
    "@qicgroupdoha/qic-use": "1.3.7",
    "@qicgroupdoha/travel-devkit": "0.0.47",
    "@sentry/vue": "10.50.0",
    "@vitejs/plugin-vue": "6.0.5",
    "@vuelidate/core": "2.0.3",
    "@vuelidate/validators": "2.0.4",
    "@vuepic/vue-datepicker": "7.4.1",
    "@vueuse/core": "14.2.1",
    "axios": "1.19.0",
    "date-fns": "4.1.0",
    "firebase": "12.10.0",
    "nanoid": "5.1.6",
    "pinia": "3.0.4",
    "vite": "8.0.0",
    "vue": "3.5.30",
    "vue-i18n": "11.3.0",
    "vue-router": "5.0.3",
    "vue-scrollto": "2.20.0",
    "vue-virtual-scroller": "2.0.0-beta.8"
  },
  "devDependencies": {
    "@pinia/testing": "1.0.3",
    "@qicgroupdoha/eslint-plugin-qic-rules": "1.2.0",
    "@qicgroupdoha/lokalise-cli": "1.1.4",
    "@rolldown/binding-linux-x64-gnu": "1.0.0-rc.9",
    "@sentry/vite-plugin": "5.2.0",
    "@testing-library/jest-dom": "6.9.1",
    "@testing-library/vue": "8.1.0",
    "@types/googlepay": "0.7.10",
    "@vitest/coverage-v8": "4.1.0",
    "@vue/test-utils": "2.4.6",
    "eslint": "10.0.3",
    "eslint-config-prettier": "10.1.8",
    "eslint-plugin-only-warn": "1.2.1",
    "eslint-plugin-vue": "10.8.0",
    "globals": "17.4.0",
    "jsdom": "29.1.1",
    "prettier": "3.8.1",
    "rollup-plugin-visualizer": "7.0.1",
    "sass": "1.98.0",
    "typescript-eslint": "8.57.0",
    "vite-plugin-html": "3.2.2",
    "vitest": "4.1.0",
    "vue-tsc": "3.2.5"
  },
  "packageManager": "pnpm@10.34.5+sha256.ccb5c479cab1b00621325bfe7d4c9a8a8031e7a525d7249e275ecbec81b08db2"
}
